import { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Context from '../../utils/context.js';
import { getMentorMatchFromProfile } from '../../api/profiles.js';
import { updateMatchAndSet } from '../../helpers/mentor_match_helper.js';

const readStoredMatch = () => {
  try {
    const raw = sessionStorage.getItem('mentorMatch');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const readStoredPatientPartner = () => {
  try {
    const raw = sessionStorage.getItem('patientPartner');
    return raw ? JSON.parse(raw) : '';
  } catch {
    return '';
  }
};

export const useQuestionnaireMatch = ({
  id,
  basePath,
  getInitialStepUrl,
  mentorMatchRoute = 'patient-partner',
} = {}) => {
  const context = useContext(Context);
  const history = useHistory();
  const initialMatch = readStoredMatch();
  const initialData = initialMatch?.data || {};

  const [match, setMatch] = useState(initialMatch);
  const [patientPartner, setPatientPartner] = useState(readStoredPatientPartner);
  const [mentorFound, setMentorFound] = useState(null);

  const update = useCallback(
    (params, callback) => {
      updateMatchAndSet({
        uuid: match?.uuid,
        id,
        params,
        setMentorMatch: setMatch,
        callback,
      });
    },
    [match?.uuid, id]
  );

  useEffect(() => {
    if (!basePath) return;
    if (mentorFound && patientPartner) {
      history.push(`${basePath}/${mentorMatchRoute}`);
    }
  }, [mentorFound, patientPartner, basePath, history, mentorMatchRoute]);

  useEffect(() => {
    if (!context.auth.isLoggedIn()) return;
    getMentorMatchFromProfile((fetched) => {
      sessionStorage.setItem('mentorMatch', JSON.stringify(fetched));
      setMatch(fetched);
      if (getInitialStepUrl && basePath && history.location.pathname === basePath) {
        history.push(getInitialStepUrl(fetched));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    initialMatch,
    initialData,
    match,
    setMatch,
    update,
    patientPartner,
    setPatientPartner,
    mentorFound,
    setMentorFound,
  };
};
